import { http, URL } from "./http.service";
import { errorHandler } from "./error.service";

export const createSuplier = async (bussinessUuid, payload) => {
  try {
    let resp = await http.post(
      `${URL}/vendor/${bussinessUuid}/create`,
      payload
    );
    return resp;
  } catch (error) {
    errorHandler(error);
  }
};

export const getSuplier = async (bussinessUuid,params={}) => {
  try {
    const queryString = new URLSearchParams(params).toString();
    let resp = await http.get(`${URL}/vendor/${bussinessUuid}/get-suplier?${queryString}`);
    return resp;
  } catch (error) {
    errorHandler(error);
  }
};
export const updateSupplier = async (bussinessUuid, vendorUuid, data) => {
  try {
    const result = await http.put(
      `${URL}/vendor/${bussinessUuid}/${vendorUuid}`,
      data
    );
    return result;
  } catch (error) {
    errorHandler(error);
  }
};

export const deleteSupplier = async (bussinessUuid, vendorUuid) => {
  try {
    const result = await http.delete(
      `${URL}/vendor/${bussinessUuid}/${vendorUuid}`
    );
    return result;
  } catch (error) {
    errorHandler(error);
  }
};
